import { z } from 'zod'

export const MEMBERSHIP_SCIM_READ_CONTRACT_VERSION = '1.0.0' as const

export const membershipScimReadResponseSchema = z.record(z.unknown())

export type MembershipScimReadResponse = z.infer<typeof membershipScimReadResponseSchema>
